/* theme.js — base IIFE, extended per task as sections/snippets are built.
   Namespace: window.theme. Sticky header is handled entirely by CSS
   (`header.site{position:sticky}` in theme.css); this file only wires the
   mobile menu toggle for now (`.burger` -> `.menu.open`). Later tasks
   (cart drawer, predictive search, add-to-cart AJAX, quantity selectors,
   PDP gallery/accordion) extend `theme` with more init functions. */
(function () {
  'use strict';

  var theme = window.theme || {};

  function initMobileMenu() {
    var burger = document.querySelector('.burger');
    var menu = document.querySelector('.menu');
    if (!burger || !menu) return;

    function closeMenu() {
      menu.classList.remove('open');
      burger.setAttribute('aria-expanded', 'false');
    }

    function toggleMenu() {
      var isOpen = menu.classList.toggle('open');
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    burger.addEventListener('click', toggleMenu);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.classList.contains('open')) {
        closeMenu();
        burger.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (!menu.classList.contains('open')) return;
      if (menu.contains(event.target) || burger.contains(event.target)) return;
      closeMenu();
    });
  }

  // sections/main-collection.liquid + snippets/facets.liquid: auto-submit
  // the shared `#FacetFiltersForm` (checkboxes/select/price inputs, see
  // facets.liquid for why they're all one form) so picking a facet or
  // changing sort behaves like a native filter UI instead of requiring an
  // explicit "Apply" button. Price number inputs submit on Enter or once
  // their value actually changes (native `change` fires on blur-after-edit)
  // rather than on every blur, to avoid re-submitting an untouched field.
  function initFacets() {
    var form = document.getElementById('FacetFiltersForm');
    if (!form) return;

    var checkboxes = form.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < checkboxes.length; i++) {
      checkboxes[i].addEventListener('change', function () {
        form.submit();
      });
    }

    var sortSelect = form.querySelector('select[name="sort_by"]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        form.submit();
      });
    }

    var priceInputs = form.querySelectorAll('.price-range input[type="number"]');
    for (var j = 0; j < priceInputs.length; j++) {
      priceInputs[j].addEventListener('change', function () {
        form.submit();
      });
      priceInputs[j].addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          form.submit();
        }
      });
    }
  }

  // sections/main-collection.liquid: turns `<aside class="filters">` into
  // a full-screen drawer below the 980px breakpoint (desktop keeps the
  // sticky sidebar untouched, see theme.css "theme additions"). Mirrors
  // initMobileMenu's open/close/Escape/outside-click pattern above.
  function initFilterDrawer() {
    var toggle = document.getElementById('FiltersToggle');
    var panel = document.getElementById('SiteFilters');
    if (!toggle || !panel) return;

    var closeBtn = document.getElementById('FiltersClose');
    var overlay = document.getElementById('FiltersOverlay');

    function openDrawer() {
      panel.classList.add('drawer-open');
      if (overlay) overlay.classList.add('open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      panel.classList.remove('drawer-open');
      if (overlay) overlay.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function () {
      if (panel.classList.contains('drawer-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && panel.classList.contains('drawer-open')) {
        closeDrawer();
        toggle.focus();
      }
    });
  }

  // SP1 scroll reveal (roadmap 2026-07-06). Sobrio-premium fade+rise for any
  // element carrying `.reveal` (see theme.css). We only hide elements once JS
  // is confirmed running: adding `.reveal-ready` to <html> flips on the CSS
  // hidden state, so a JS failure leaves everything visible instead of stuck
  // invisible. Each element reveals once (unobserve after first intersection).
  // No IntersectionObserver (very old browsers) -> reveal everything up front.
  function initScrollReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    document.documentElement.classList.add('reveal-ready');

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-visible');
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      for (var j = 0; j < entries.length; j++) {
        if (entries[j].isIntersecting) {
          entries[j].target.classList.add('is-visible');
          obs.unobserve(entries[j].target);
        }
      }
    // Positive bottom rootMargin reveals each element ~14% before it scrolls
    // into view, so content is already settling in by the time it's on screen
    // (no "empty section then pop"). threshold 0 = any sliver counts.
    }, { rootMargin: '0px 0px 14% 0px', threshold: 0 });

    for (var k = 0; k < els.length; k++) io.observe(els[k]);

    // Failsafe: after 1.2s reveal anything already within (or above) the
    // viewport that the observer somehow hasn't fired for — so on-screen
    // content can never sit blank. Elements still below the fold are left
    // alone so they keep animating in on scroll.
    window.setTimeout(function () {
      for (var m = 0; m < els.length; m++) {
        if (els[m].getBoundingClientRect().top < window.innerHeight) {
          els[m].classList.add('is-visible');
        }
      }
    }, 1200);
  }

  theme.initMobileMenu = initMobileMenu;
  theme.initFacets = initFacets;
  theme.initFilterDrawer = initFilterDrawer;
  theme.initScrollReveal = initScrollReveal;
  window.theme = theme;

  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    initFacets();
    initFilterDrawer();
    initScrollReveal();
  });
})();
